import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import FormCard from '../forms/FormCard';
import VarbutibaEditModal from './VarbutibaEditModal';
import { isNovertejumsEditableByUser } from './riskaNovertejumsUtils';
import {
    IPATSVARS,
    kategorijaIpatsvarsColumns,
    kategorijaColumns,
    riskaObjektiColumns,
} from './DzeramaUdensSatecesBaseinsAktualaSituacija';
import {
    updateRiskaObjektaVarbutiba,
    updateRiskaKategorijasVarbutiba,
    loadRiskaNovertejums,
    loadRiskaNovertejumuObjekti,
    riskaNovertejumuObjektSelected
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

const makeButtonColumn = (dataField, isEditable, onClick) => ({
    dataField, text: '', isDummyField: true,
    formatter: (_cell, row) => (
        <Button color="secondary" size="sm" onClick={(e) => { e.stopPropagation(); onClick(row); }}>
            <i className={isEditable ? "fa fa-pencil" : "fa fa-file-text-o"}></i>
        </Button>
    ),
    classes: 'td-button', headerStyle: { width: 36 }
});

class RiskaNovertejumsObjekti extends Component {
    state = {
        expanded: {},
        editModal: null,
        editingItem: null,
    };

    componentDidUpdate(prevProps) {
        const { selectedObjektId, objekti } = this.props;
        if (selectedObjektId !== prevProps.selectedObjektId && selectedObjektId) {
            const kat = objekti?.find(k => k.riska_objekti?.find(ro => ro.id === selectedObjektId));
            if (kat) {
                this.setState(prev => ({
                    expanded: { ...prev.expanded, [kat.id]: true }
                }));
            }
        }
    }

    closeModal = () => this.setState({ editModal: null, editingItem: null });

    handleSaveObjekt = (id, varbutiba, komentars) => {
        const { updateRiskaObjektaVarbutiba, loadRiskaNovertejums, loadRiskaNovertejumuObjekti, id: novertejumsId } = this.props;
        updateRiskaObjektaVarbutiba(id, varbutiba, komentars).then(() => {
            loadRiskaNovertejums(novertejumsId);
            loadRiskaNovertejumuObjekti(novertejumsId);
            this.closeModal();
        });
    }

    handleSaveKategorija = (id, varbutiba, komentars) => {
        const { updateRiskaKategorijasVarbutiba, loadRiskaNovertejums, loadRiskaNovertejumuObjekti, id: novertejumsId } = this.props;
        updateRiskaKategorijasVarbutiba(id, varbutiba, komentars).then(() => {
            loadRiskaNovertejums(novertejumsId);
            loadRiskaNovertejumuObjekti(novertejumsId);
            this.closeModal();
        });
    }

    renderKategorijaTable = (kategorija, isEditable) => {
        const { id, nosaukums_display, kriterija_tips, riska_objekti } = kategorija;
        const hasObjekti = riska_objekti?.length > 0;

        const katColumns = [
            ...(isEditable ? [makeButtonColumn('df_edit_kat', true, (row) => this.setState({ editModal: 'kategorija', editingItem: row }))] : []),
            ...(kriterija_tips === IPATSVARS ? kategorijaIpatsvarsColumns : kategorijaColumns)
        ];
        const objColumns = [
            makeButtonColumn('df_obj_btn', isEditable, (row) => this.setState({ editModal: 'objekt', editingItem: row })),
            ...riskaObjektiColumns
        ];

        return (
            <div key={id}>
                <h5>{nosaukums_display}</h5>
                <BootstrapTable
                    keyField="id"
                    data={[kategorija]}
                    columns={katColumns}
                    bootstrap4 striped hover condensed
                    rowEvents={{
                        onClick: (_e, row) => this.setState(prev => ({
                            expanded: { ...prev.expanded, [row.id]: !prev.expanded[row.id] }
                        }))
                    }}
                    expandRow={hasObjekti ? {
                        renderer: (row) => row.riska_objekti?.length > 0 ? (
                            <BootstrapTable
                                keyField="id"
                                data={row.riska_objekti}
                                columns={objColumns}
                                bootstrap4 striped hover condensed
                                rowEvents={{ onClick: (_e, r) => this.props.riskaNovertejumuObjektSelected(r.id) }}
                                rowClasses={(row) => row.id === this.props.selectedObjektId ? 'table-primary' : ''}
                            />
                        ) : null,
                        expanded: this.state.expanded[id] ? [id] : [],
                        showExpandColumn: false,
                        expandByColumnOnly: false,
                    } : undefined}
                />
            </div>
        );
    }

    render() {
        const { objekti, novertejums, kodif } = this.props;
        const { editModal, editingItem } = this.state;
        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);

        if (!objekti || objekti.length === 0) {
            return (
                <FormCard title="Riska objekti" size={12}>
                    <Alert color="info">Nav riska objektu</Alert>
                </FormCard>
            );
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                {objekti.map((x, i, arr) =>
                    i === 0 || x.riska_kategorija_grupa !== arr[i - 1].riska_kategorija_grupa ? (
                        <FormCard key={x.riska_kategorija_grupa} title={x.riska_kategorija_grupa} size={12}>
                            {arr.slice(i).filter(y => y.riska_kategorija_grupa === x.riska_kategorija_grupa)
                                .map(y => this.renderKategorijaTable(y, isEditable))}
                        </FormCard>
                    ) : null
                )}

                <VarbutibaEditModal
                    isOpen={editModal === 'objekt'}
                    toggle={this.closeModal}
                    title={isEditable ? 'Labot riska objekta novērtējumu' : 'Riska objekta informācija'}
                    item={editingItem}
                    isEditable={isEditable}
                    showDetailFields
                    riskaVarbutiba={kodif.riskaVarbutiba}
                    onSave={this.handleSaveObjekt}
                />

                <VarbutibaEditModal
                    isOpen={editModal === 'kategorija'}
                    toggle={this.closeModal}
                    title={isEditable ? 'Labot kategorijas novērtējumu' : 'Kategorijas informācija'}
                    item={editingItem}
                    isEditable={isEditable}
                    showDetailFields={false}
                    riskaVarbutiba={kodif.riskaVarbutiba}
                    onSave={this.handleSaveKategorija}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const riskaNovertejumi = state.riskaNovertejumi || {};
    return {
        novertejums: riskaNovertejumi.selectedItem,
        objekti: riskaNovertejumi.objektiList || [],
        selectedObjektId: riskaNovertejumi.selectedObjektId,
        kodif: state.kodif || {},
        user: state.user || {}
    };
};

export default connect(mapStateToProps, {
    updateRiskaObjektaVarbutiba,
    updateRiskaKategorijasVarbutiba,
    loadRiskaNovertejums,
    loadRiskaNovertejumuObjekti,
    riskaNovertejumuObjektSelected
})(RiskaNovertejumsObjekti);
